import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../shared/ErrorFallback";
import InfoPage from "../info/InfoPage";
import PageLoading from "../shared/PageLoading";

interface IParams {
	articleId: string;
}

interface IProps extends RouteComponentProps<IParams> {
	loggedIn: boolean | undefined;
	loading: React.ReactElement;
}

const LazyFanbox = lazy(() => import(/* webpackChunkName: "Fanbox" */ "../fanbox/Fanbox"));
const LazyPost = lazy(() => import(/* webpackChunkName: "FanboxPost" */ "../fanbox/Post"));

const FanboxPage: FunctionComponent<IProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { loggedIn, path, loading, articleId } = props;

	if (loggedIn === undefined) {
		return loading;
	}

	if (!loggedIn) {
		return <InfoPage />;
	}

	if (articleId) {
		return <ErrorBoundary FallbackComponent={ErrorFallback}>
			<LazyPost articleId={articleId} />
		</ErrorBoundary>;
	}

	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyFanbox loading={loading} />
	</ErrorBoundary>;
};

export default FanboxPage;